import {
  Dialog,
  DialogContent,
  DialogTitle,
  makeStyles,
  Menu,
  Paper,
  Switch,
  Table,
  Button,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import clsx from "clsx";
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import AdminTitle2 from "components/admin/smart-visa/AdminTitle2";
import ColorButton from "components/common/ColorButton";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import EmployeeService from "services/EmployeeService";
import AddIcon from "@material-ui/icons/Add";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import { get } from "lodash";
import { boiDepartmentId } from "libs/configs/constant";
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const GreenCheckbox = withStyles((theme) => ({
  root: {
    color: theme.palette.success.main,
    "&$checked": {
      color: theme.palette.success.main,
    },
  },
  checked: {},
}))((props) => <Checkbox color="default" {...props} />);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  warpDialog: {
    // padding: "30px", minWidth: "600px", minHeight: "200px"
  },
  paper: {
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  content: {
    marginTop: 30,
  },
  warpSubHeader: {
    marginTop: 20,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  buttonDialogSave: {
    width: "100%",
    margin: "15px 5px",
  },
  table: {
    minWidth: 700,
  },
  tableHead: {
    backgroundColor: "#F1F3F9",
    color: "#8898AA",
  },

  warpButtonDetail: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  center: {
    textAlign: "center",
  },
  warpRespon: {
    textAlign: "right",
  },
  btnActive: {
    color: "#2DCE98",
    border: "1px solid #2DCE98",
    backgroundColor: " white",
    marginRight: 10,
    width: 75,
  },
  btnInActive: {
    color: "#F53C56",
    border: "1px solid #F53C56",
    backgroundColor: " white",
    marginRight: 10,
    width: 75,
  },
  dtitle: {
    color: "#40B8D4",
  },
  d2title: {
    color: "#172B4D",
    paddingBottom: 10,
  },
  textDialog: {
    width: "100%",
  },
  warpButtonDialogSave: {
    display: "flex",
  },
  warpRowDialog: {
    marginTop: 10,
  },
  warpRowDateDialog: {
    display: "flex",
  },
  formControl: {
    width: "100%",
  },
  warpFormControl: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  buttonStatusDetail: {
    cursor: "pointer",
  },
}));

function EmployeePage() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [employeeList, setEmployeeList] = React.useState([]);
  const profile = useSelector((state) => state.user.profile);
  const [dialogData, setDialogData] = React.useState({});
  const [open, setOpen] = React.useState(false);
  const history = useHistory();
  const masterData = useSelector(selectMasterData);
  const department = get(masterData, "department", []);
  const [departmentSearchId, setDepartmentSearchId] = useState("");
  const [isCheckAll, setIsCheckAll] = useState(false);
  useEffect(async () => {
    await setDepartmentSearchId(profile?.departmentId);
    // await getEmployeeList();
  }, [profile]);

  useEffect(async () => {
    await setDepartmentSearchId(profile?.departmentId);
    await dispatch(
      getMasterData({
        department: true,
      })
    );
  }, []);

  useEffect(async () => {
    if (departmentSearchId !== undefined && departmentSearchId !== "") {
      console.log("id " + departmentSearchId);
      await getEmployeeList();
    }
    console.log(departmentSearchId);
  }, [departmentSearchId]);

  // params Department ID ตรงนี้
  const getEmployeeList = async () => {
    const response = await EmployeeService.list({
      departmentId: departmentSearchId,
      allStatus: true,
    });

    if (response.status) {
      setEmployeeList(response.results);
      console.log(response.results);
    }
    // if (
    //   departmentSearchId !== profile?.departmentId &&
    //   departmentSearchId !== undefined &&
    //   departmentSearchId !== null &&
    //   departmentSearchId !== ""
    // ) {
    //   const response = await EmployeeService.list({
    //     departmentId: departmentSearchId,
    //     allStatus: true,
    //   });

    //   if (response.status) {
    //     setEmployeeList(response.results);
    //   }
    // } else {

    // }
  };

  const handleClose = async (value) => {
    setOpen(false);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);

  return (
    <Paper className={classes.paper}>
      <AdminTitle title="Setting" subTitle="จัดการข้อมูลพนักงาน" />
      <LogsDialog data={dialogData} open={open} onClose={handleClose} />
      <div className={classes.warpSubHeader}>
        <AdminTitle2 subTitle="รายชื่อพนักงาน" />

        <div>
          <Button
            variant="contained"
            size="medium"
            color="primary"
            href="/admin/setting/Addemployee/"
            className={classes.buttonDialogSave}
          >
            <AddIcon />
            เพิ่มพนักงาน
          </Button>
        </div>
      </div>

      <Grid item xs={12} md={12}>
        <div className={classes.wrapField}>
          {!isCheckAll && profile?.departmentId === boiDepartmentId ? (
            <>
              <InputLabel>Department</InputLabel>
              <FormControl variant="outlined" className={classes.textField}>
                <Select
                  value={departmentSearchId}
                  name="departmentId"
                  onChange={(e) => {
                    setDepartmentSearchId(e.target.value);
                  }}
                >
                  {department.map((config) => (
                    <MenuItem
                      key={config.departmentId}
                      value={config.departmentId}
                    >
                      {config.departmentName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </>
          ) : null}
          {profile?.departmentId === boiDepartmentId ? (
            <div className={classes.warpRespon}>
              <FormControlLabel
                control={<GreenCheckbox />}
                name="responsible"
                // value={formik.values.responsible}
                checked={isCheckAll}
                onClick={async (e) => {
                  setIsCheckAll(!isCheckAll);
                  if (e.target.checked) {
                    await setDepartmentSearchId(null);
                    // await getEmployeeList();
                  } else {
                    await setDepartmentSearchId(profile?.departmentId);
                    // await getEmployeeList();
                  }
                }}
                label="ALL Department"
              />
            </div>
          ) : null}
        </div>
      </Grid>

      <div className={classes.content}>
        <div className={classes.warpData}>
          <TableContainer>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    className={clsx(classes.tableHead, classes.center)}
                  >
                    #
                  </StyledTableCell>
                  <StyledTableCell
                    className={clsx(classes.tableHead, classes.center)}
                  >
                    ชื่อ
                  </StyledTableCell>
                  <StyledTableCell
                    className={clsx(classes.tableHead, classes.center)}
                  >
                    สกุล
                  </StyledTableCell>
                  <StyledTableCell
                    className={clsx(classes.tableHead, classes.center)}
                  >
                    หน่วยงาน
                  </StyledTableCell>

                  <StyledTableCell
                    className={clsx(classes.tableHead, classes.center)}
                  >
                    สิทธิ์
                  </StyledTableCell>
                  <StyledTableCell
                    className={clsx(classes.tableHead, classes.center)}
                  >
                    ใช้งาน
                  </StyledTableCell>
                  <StyledTableCell
                    className={clsx(classes.tableHead, classes.center)}
                  >
                    จัดการ
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {employeeList.map((row, index) => (
                  <StyledTableRow key={row.name}>
                    <StyledTableCell
                      component="th"
                      scope="row"
                      className={classes.center}
                    >
                      {" "}
                      {index + 1}
                    </StyledTableCell>
                    <StyledTableCell className={classes.center}>
                      {row?.employeeFistName}
                    </StyledTableCell>

                    <StyledTableCell className={classes.center}>
                      {row?.employeeLastName}
                    </StyledTableCell>

                    <StyledTableCell className={classes.center}>
                      {row?.departmentName}
                    </StyledTableCell>

                    <StyledTableCell className={classes.center}>
                      {row?.roleName}
                    </StyledTableCell>
                    <StyledTableCell className={classes.center}>
                      <Switch
                        checked={row?.status}
                        onChange={async (event) => {
                          const res = await EmployeeService.updateStatus({
                            empId: row?.empId,
                            status: event.target.checked,
                          });
                          if (res.status) {
                            await getEmployeeList();
                          }
                        }}
                      />
                    </StyledTableCell>
                    <StyledTableCell className={classes.center}>
                      <ColorButton
                        size="small"
                        style={{ marginRight: 15 }}
                        variant="outlined"
                        onClick={() => {
                          history.push(`/admin/setting/employee/${row.empId}`);
                        }}
                      >
                        View
                      </ColorButton>
                      <ColorButton
                        size="small"
                        // style={{ height: 40, width: 120}}
                        variant="outlined"
                        onClick={() => {
                          setDialogData({ empId: row?.empId });

                          setOpen(true);
                        }}
                      >
                        Logs
                      </ColorButton>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={openMenu}
        onClose={() => {
          setAnchorEl(null);
        }}
      ></Menu>
    </Paper>
  );
}

export default EmployeePage;

export function LogsDialog(props) {
  const classes = useStyles();
  const { onClose, open, data } = props;
  const [Logs, setLogs] = React.useState([]);

  const handleClose = () => {
    onClose();
  };

  useEffect(async () => {
    setLogs([]);
    if (open) {
      const res = await EmployeeService.logs({ empId: data.empId });

      if (res.status) {
        setLogs(res.results);
      }
      console.log(res);
    }
  }, [open]);

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth={true}
      className={classes.warpDialog}
      maxWidth="lg"
    >
      <DialogTitle id="simple-dialog-title" className={classes.dtitle}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>ประวัติการทำรายการ</span>
          <ColorButton size="small" variant="outlined" onClick={handleClose}>
            ปิด
          </ColorButton>
        </div>
      </DialogTitle>

      <DialogContent>
        <TableContainer>
          <Table className={classes.table} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell
                  className={clsx(classes.tableHead, classes.center)}
                >
                  #
                </StyledTableCell>
                <StyledTableCell
                  className={clsx(classes.tableHead, classes.center)}
                >
                  Date
                </StyledTableCell>
                <StyledTableCell className={classes.tableHead}>
                  Employee Name
                </StyledTableCell>
                <StyledTableCell className={classes.tableHead}>
                  Log
                </StyledTableCell>
                <StyledTableCell className={classes.tableHead}>
                  Remark
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Logs.map((row, index) => (
                <StyledTableRow key={row.name}>
                  <StyledTableCell
                    component="th"
                    scope="row"
                    className={classes.center}
                  >
                    {" "}
                    {index + 1}
                  </StyledTableCell>
                  <StyledTableCell className={classes.center}>
                    {format(new Date(row.createDate), "yyyy-MM-dd")}
                  </StyledTableCell>
                  <StyledTableCell>{row?.empName}</StyledTableCell>
                  <StyledTableCell>{row?.statusName}</StyledTableCell>
                  <StyledTableCell>{row?.remark}</StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
}
